// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"113":"a803ba3f","142":"e1d969aa","438":"71b7ac96","538":"66a1b2c7","648":"85511e18","960":"7581e51a"}[chunkId] + ".chunk.js";
};